import { Component, Input, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-simple-modal',
  templateUrl: './simple-modal.component.html',
  styleUrls: ['./simple-modal.component.scss']
})
export class SimpleModalComponent  {

  @Input()
  title: string;

  @Input()
  infoIcon: boolean;

  @Input()
  modalType: string; //'success' | 'error'|'warning';

  @Input()
  contentText: string;

  @Input()
  contentTemplate: TemplateRef<any>;

  @Input()
  buttons: ButtonModel[];

  @Input()
  redirectTo: string;

  @Input()
  showCloseIcon: boolean = true;

  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<SimpleModalComponent>
  ) { }

  close() {
    if(this.redirectTo)
    {
      this.router.navigate([this.redirectTo]);
    }
  }

}

export interface ButtonModel {
  title: string;
  icon?: string;
  type: 'button-primary' | 'button-secondary' | 'button-important' | 'button-secondary-important';
  action: (dialogRef?: MatDialogRef<any>) => void;
}
